import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Exam from './components/Exam';
import ResultView from './components/ResultView';
import ArticleView from './components/ArticleView';
import DailyResults from './components/DailyResults';

import Analytics from './components/Analytics';
import SuffaDars from './components/SuffaDars';
import SuffaAdmin from './components/SuffaAdmin';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';

// Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <h2>Something went wrong</h2>
          <button onClick={() => window.location.reload()}>Reload Page</button>
        </div>
      );
    }
    return this.props.children;
  }
}

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/" replace />;
  }
  return children;
};

// Admin Protected Route Component
const AdminProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('admin_token');
  if (!token) {
    return <Navigate to="/react-user/login" replace />;
  }
  return children;
};

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          {/* User Routes */}
          <Route path="/react-user" element={<Navigate to="/react-user/login" replace />} />
          <Route path="/react-user/login" element={<AdminLogin />} />
          <Route path="/react-user/dashboard" element={<AdminProtectedRoute><AdminDashboard /></AdminProtectedRoute>} />

          {/* Suffa Dars Routes */}
          <Route path="/suffa_dars" element={<SuffaDars />} />
          <Route path="/suffa_dars/admin" element={<SuffaAdmin />} />

          {/* Student Exam Routes */}
          <Route path="/student-react" element={<Login />} />
          <Route path="/student-react/analytics" element={<Analytics />} />
          <Route
            path="/student-react/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard isTestChannel={false} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/student-react/test-channel"
            element={
              <ProtectedRoute>
                <Dashboard isTestChannel={true} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/student-react/test/:questionnaireId"
            element={
              <ProtectedRoute>
                <Exam />
              </ProtectedRoute>
            }
          />
          <Route
            path="/student-react/result/:id"
            element={
              <ProtectedRoute>
                <ResultView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/student-react/article"
            element={
              <ProtectedRoute>
                <ArticleView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/student-react/daily-results"
            element={
              <ProtectedRoute>
                <DailyResults />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/student-react" replace />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
